export const i18n = {
  defaultLocale: 'en-US',
  locales: ['en-US', 'it'],
} as const;

// This helper type extracts the locale strings into a union: 'en-US' | 'fr' | 'nl-NL'
export type Locale = (typeof i18n)['locales'][number];